import axios from 'axios';

import { getAPIUrl } from './baseAPI';
import { PriceBreakdown, Quote, RateTierService } from 'types/domainModels';

export const GET_QUOTE = () => ({
  path: '/prices/quote',
  version: 'v1' as const,
});

export async function getQuote({
  data,
}: {
  data: {
    incidence: number;
    questionCount: number;
    respondentsCount: number;
    services: RateTierService[];
    multiplierOptions: number[];
    version?: number;
  };
}) {
  return (await axios.post<Quote>(getAPIUrl(GET_QUOTE()), data)).data;
}

export const GET_PRICE_BREAKDOWN = () => ({
  path: '/prices/breakdown',
  version: 'v1' as const,
});

export async function getPriceBreakdown({
  data,
}: {
  data: {
    incidence: number;
    questionCount: number;
    respondentsCount: number;
    multiplierOptions?: number[];
  };
}) {
  return (
    await axios.post<PriceBreakdown>(getAPIUrl(GET_PRICE_BREAKDOWN()), data)
  ).data;
}
